import React from 'react';
import { useQuran } from '../context/QuranContext';
import { Languages, ChevronDown } from 'lucide-react';
import {
    DropdownMenu,
    DropdownMenuTrigger,
    DropdownMenuContent,
    DropdownMenuCheckboxItem,
} from './ui/dropdown-menu';
import { ScrollArea } from './ui/scroll-area';

const TranslationSelector = () => {
    const { translations, selectedTranslators, setSelectedTranslators } = useQuran();

    const toggleTranslator = (id) => {
        setSelectedTranslators(prev => {
            if (prev.includes(id)) {
                // Prevent unchecking the last selected translator
                if (prev.length === 1) return prev;
                return prev.filter(tId => tId !== id);
            } else {
                return [...prev, id];
            }
        });
    };

    // Determine what to show on the trigger button
    let triggerDisplay = 'Translator';
    if (selectedTranslators.length === 1) {
        triggerDisplay = translations.find(t => t.id === selectedTranslators[0])?.name || 'Translator';
    } else if (selectedTranslators.length > 1) {
        triggerDisplay = `${selectedTranslators.length} Translations Selected`;
    }

    return (
        <div className="flex-1 min-w-0" data-testid="translation-selector-container">
            <DropdownMenu>
                <DropdownMenuTrigger 
                    className="w-full h-10 px-3 bg-[#09090b]/80 border border-[#1e293b] rounded-md text-[#f8fafc] hover:border-[#d4af37] transition-colors text-sm focus:outline-none flex justify-between items-center"
                    data-testid="translation-select-trigger"
                >
                    <div className="flex items-center gap-2 truncate">
                        <Languages className="w-4 h-4 text-[#d4af37] flex-shrink-0" />
                        <span className="truncate">{triggerDisplay}</span>
                    </div>
                    <ChevronDown className="w-4 h-4 opacity-50 flex-shrink-0" />
                </DropdownMenuTrigger>
                <DropdownMenuContent 
                    className="w-72 bg-[#09090b] border-[#1e293b] p-0"
                    data-testid="translation-select-content"
                    align="end"
                >
                    <ScrollArea className="h-[40vh] p-1">
                        {translations.map((translator) => (
                            <DropdownMenuCheckboxItem
                                key={translator.id}
                                checked={selectedTranslators.includes(translator.id)}
                                onSelect={(e) => {
                                    e.preventDefault(); // Keep dropdown open on select
                                    toggleTranslator(translator.id);
                                }}
                                className="py-2 px-3 hover:bg-[#1e293b] cursor-pointer focus:bg-[#1e293b] focus:text-[#f8fafc]"
                            >
                                <div className="flex flex-col ml-2">
                                    <span className="text-[#f8fafc] text-sm">{translator.name}</span>
                                    {translator.author_name && translator.author_name !== translator.name && (
                                        <span className="text-[#475569] text-xs">{translator.author_name}</span>
                                    )}
                                </div>
                            </DropdownMenuCheckboxItem>
                        ))}
                    </ScrollArea>
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
};

export default TranslationSelector;
